import {
    registerFormInputComponent,
} from '@vendure/admin-ui/core';
import { GMCSettingInputComponent } from './components/gmc-settings-form';

export default [
    registerFormInputComponent('gmc-settings-input-form', GMCSettingInputComponent),
];
